import React, {Component} from "react";

require("./tournament-banner.css");
class TournamentBanner extends Component {




    render() {
        let {tournament_data, show_func} = this.props;

        let prefix = "Live Now:";

        if (!tournament_data.active) {
            prefix = "Recently Ended:";
        }

        return (
            <div className='tournament_banner' onClick={show_func}>{prefix} {tournament_data.name} <span className='tournament_banner_more_info'> (Click for more info)</span></div>
        );
        
    }
}

export default TournamentBanner;



// WEBPACK FOOTER //
// ./src/components/containers/tournaments/tournament-banner.js